// menus — see README.md. Keys must exist in BOTH maps (checked by npm run check:locales).
export const en = {
  // --- Shared across the menu screens --------------------------------------
  // --- Kiosk: whether a self-order panel offers this card -------------------
  'menus.kiosk.label': 'Kiosk',
  'menus.kiosk.show': 'Show this menu on kiosks',
  'menus.kiosk.hint': 'Untick and self-order kiosks will not offer it. The QR menu, the website and the order screen are unaffected.',
  'menus.kiosk.notOn': 'Not on kiosks',

  'menus.toast.success': 'Success',
  'menus.toast.error': 'Error',
  'menus.badge.active': '● Active',
  'menus.noRestaurant': 'No restaurant selected. Please select a restaurant first.',
  'menus.debugInfo': 'Debug Info:',
  'menus.goToSetup': 'Go to Restaurant Setup',

  // --- All Menu Items (catalogue) ------------------------------------------
  'menus.dishes.eyebrow': 'Menu catalogue',
  'menus.dishes.count': '{shown} of {total} dishes',
  'menus.dishes.addItem': 'Add Menu Item',
  'menus.dishes.loadedCount': 'Loaded {n} dishes',
  'menus.dishes.loadFailed': 'Failed to load dishes',

  // Plural type buckets — used by the "Show Only" filter and the Type grouping.
  'menus.dishes.type.dish': 'Dishes',
  'menus.dishes.type.beverage': 'Beverages',
  'menus.dishes.type.addon': 'Add-ons',
  'menus.dishes.type.combo': 'Combos',
  'menus.dishes.type.store_bought': 'Store-bought',
  'menus.dishes.type.bakery': 'Bakery',
  'menus.dishes.type.liquor': 'Liquor',
  'menus.dishes.group.uncategorized': 'Uncategorized',
  'menus.dishes.group.other': 'Other',
  'menus.dishes.group.items.one': '{n} item',
  'menus.dishes.group.items.other': '{n} items',

  // Draft deletion
  'menus.dishes.deleteDraft.title': 'Delete draft?',
  'menus.dishes.deleteDraft.description': 'Delete draft "{name}"? This can\'t be undone.',
  'menus.dishes.deleteDraft.done': 'Draft deleted',
  'menus.dishes.deleteDraft.doneDesc': '"{name}" was removed.',
  'menus.dishes.deleteDraft.failed': 'Delete failed',
  'menus.dishes.deleteDraft.failedDesc': 'Could not delete the draft.',

  // Per-branch availability
  'menus.dishes.noLocation.title': 'No location selected',
  'menus.dishes.noLocation.desc': 'Pick a location first to change availability for this branch.',
  'menus.dishes.availableHere.title': 'Available here',
  'menus.dishes.unavailableHere.title': 'Unavailable here',
  'menus.dishes.availOnDesc': '"{name}" is now on the ordering menu at {location}.',
  'menus.dishes.availOffDesc': '"{name}" is now off the ordering menu at {location}.',
  'menus.dishes.thisLocation': 'this location',
  'menus.dishes.updateFailed': 'Update failed',
  'menus.dishes.availUpdateFailedDesc': 'Could not change availability.',
  'menus.dishes.availSaveFailedDesc': 'Could not update availability.',
  'menus.dishes.deactivateHere.description': '"{name}" will be turned off on the ordering screen {where}. It stays on every menu and you can reactivate it anytime.',
  'menus.dishes.atLocation': 'at {location}',
  'menus.dishes.here': 'here',
  'menus.dishes.availUpdated.title': 'Availability updated',
  'menus.dishes.availAllDesc': '"{name}" is available at every location.',
  'menus.dishes.availOffCount.one': '"{name}" is deactivated at {n} of {total} location.',
  'menus.dishes.availOffCount.other': '"{name}" is deactivated at {n} of {total} locations.',

  // Active / inactive lifecycle
  'menus.dishes.deactivateItem.title': 'Deactivate item?',
  'menus.dishes.deactivateItem.description': '"{name}" will be marked Inactive and removed from every menu (at all locations) until you reactivate it.',
  'menus.dishes.activated.title': 'Item activated',
  'menus.dishes.deactivated.title': 'Item deactivated',
  'menus.dishes.activated.desc': '"{name}" is now Active.',
  'menus.dishes.deactivated.desc': '"{name}" is now Inactive.',
  'menus.dishes.statusFailedDesc': 'Could not change status.',

  // Badges
  'menus.dishes.badge.draft': 'Draft',
  'menus.dishes.badge.offHere': 'Off here',
  'menus.dishes.badge.free': 'Free',

  // Availability summary under the Status column
  'menus.dishes.summary.allLocations': 'Available at all {n} locations',
  'menus.dishes.summary.offCount': 'Deactivated at {n} of {total}',
  'menus.dishes.summary.availableAt': 'Available at {location}',
  'menus.dishes.summary.availableHere': 'Available here',
  'menus.dishes.summary.deactivatedAt': 'Deactivated at {location}',
  'menus.dishes.summary.deactivatedHere': 'Deactivated here',

  // Table row
  'menus.dishes.variants.hide': 'Hide variants',
  'menus.dishes.variants.show': 'Show variants & prices',
  'menus.dishes.statusTitle.active': 'Active — click to deactivate (removes from every menu)',
  'menus.dishes.statusTitle.inactive': 'Inactive — click to activate',
  'menus.dishes.action.view': 'View',
  'menus.dishes.action.viewTitle': 'View details',
  'menus.dishes.action.editTitle': 'Edit item',
  'menus.dishes.action.availability': 'Availability',
  'menus.dishes.action.availabilityTitle': 'Manage availability by location',
  'menus.dishes.action.deactivateTitle': 'Deactivate at this location',
  'menus.dishes.action.reactivate': 'Reactivate',
  'menus.dishes.action.reactivateTitle': 'Reactivate at this location',
  'menus.dishes.action.deleteDraftTitle': 'Delete this draft',
  'menus.dishes.variantStandard': 'Standard',

  // Table columns
  'menus.dishes.column.name': 'Item',
  'menus.dishes.column.type': 'Type',
  'menus.dishes.column.variants': 'Variants',
  'menus.dishes.column.created': 'Created',
  'menus.dishes.sortBy': 'Sort by {column}',

  // Read-only details panel
  'menus.dishes.view.category': 'Category',
  'menus.dishes.view.created': 'Created',
  'menus.dishes.view.availability': 'Availability',
  'menus.dishes.view.variants': 'Variants ({n})',
  'menus.dishes.view.noVariants': 'No variants.',
  'menus.dishes.view.ingredients': 'Ingredients ({n})',
  'menus.dishes.view.noIngredients': 'No ingredients recorded.',
  'menus.dishes.view.allergens': 'Allergens:',
  'menus.dishes.view.recipe': 'Recipe (per variant)',
  'menus.dishes.view.ingredientFallback': 'Ingredient #{id}',
  'menus.dishes.view.close': 'Close',

  // Filters
  'menus.dishes.filter.search': 'Search Dishes',
  'menus.dishes.filter.searchPlaceholder': 'Search by name, description, or category...',
  'menus.dishes.filter.showOnly': 'Show Only',
  'menus.dishes.filter.allTypes': 'All types',
  'menus.dishes.filter.groupBy': 'Group By',
  'menus.dishes.filter.noGrouping': 'No grouping',
  'menus.dishes.filter.category': 'Category',
  'menus.dishes.filter.type': 'Type (dish / beverage / add-on / …)',
  'menus.dishes.filter.status': 'Status Filter',
  'menus.dishes.filter.showActive': 'Show Active',
  'menus.dishes.filter.showInactive': 'Show Inactive',

  // List states
  'menus.dishes.loading': 'Loading dishes…',
  'menus.dishes.empty': 'No dishes found. Add your first dish to get started!',
  'menus.dishes.noMatches': 'No dishes match your filters.',

  // Availability-by-location picker
  'menus.dishes.availDialog.title': 'Availability by location',
  'menus.dishes.availDialog.descPrefix': 'Choose where',
  'menus.dishes.availDialog.descSuffix': 'is deactivated. Ticked branches are switched off; it still stays on every menu.',
  'menus.dishes.availDialog.clearAll': 'Clear all',
  'menus.dishes.availDialog.deactivateAll': 'Deactivate at all locations',
  'menus.dishes.availDialog.primary': 'Primary',
  'menus.dishes.availDialog.deactivated': 'Deactivated',
  'menus.dishes.availDialog.available': 'Available',

  // --- Simple dishes / beverages list --------------------------------------
  'menus.dishList.searchFilter': 'Search & Filter',
  'menus.dishList.searchByName': 'Search by Name',
  'menus.dishList.searchPlaceholder': 'e.g., Butter Chicken',
  'menus.dishList.filterByCategory': 'Filter by Category',
  'menus.dishList.allCategories': 'All Categories',
  'menus.dishList.itemsPerPage': 'Items per Page',
  'menus.dishList.pageSize': '{n} items',
  'menus.dishList.clear': 'Clear',
  'menus.dishList.title.food': 'Dishes',
  'menus.dishList.title.beverage': 'Beverages',
  'menus.dishList.results': 'Showing {shown} of {total} results',
  'menus.dishList.subtitle.food': 'Manage all food items with their variants and pricing',
  'menus.dishList.subtitle.beverage': 'Manage all beverages with their variants and pricing',
  'menus.dishList.add.food': 'Add Dish',
  'menus.dishList.add.beverage': 'Add Beverage',
  'menus.dishList.empty.food': 'No dishes yet',
  'menus.dishList.empty.beverage': 'No beverages yet',
  'menus.dishList.emptyHint.food': 'Add your first dish to get started',
  'menus.dishList.emptyHint.beverage': 'Add your first beverage to get started',
  'menus.dishList.veg': 'Veg',
  'menus.dishList.vegan': 'Vegan',
  'menus.dishList.variantsLabel': 'Variants:',
  'menus.dishList.page': 'Page {n} of {total}',
  'menus.dishList.previous': 'Previous',
  'menus.dishList.next': 'Next',
  'menus.dishList.addVariantTitle': 'Add Variant for {name}',
  'menus.dishList.displayName': 'Display Name',
  'menus.dishList.dishNameWith': 'Dish Name ({name})',
  'menus.dishList.custom': 'Custom',
  'menus.dishList.size': 'Size',
  'menus.dishList.unit': 'Unit',
  'menus.dishList.price': 'Price',
  'menus.dishList.adding': 'Adding...',
  'menus.dishList.addVariant': 'Add Variant',
  'menus.dishList.loadFailed': 'Failed to load dishes',
  'menus.dishList.searchFailed': 'Failed to search dishes',
  'menus.dishList.variantMissing.title': 'Variant details missing',
  'menus.dishList.variantMissing.desc': 'Provide a label, quantity/volume, and price for the variant.',
  'menus.dishList.variantAdded': 'Variant added successfully',
  'menus.dishList.variantAddFailed': 'Failed to add variant',

  // --- Menu preview (read-only) --------------------------------------------
  'menus.view.loading': 'Loading menu...',
  'menus.view.loadFailed': 'Failed to load menu',
  'menus.view.qrFailed': 'Failed to generate QR',
  'menus.view.qrNetworkError': 'Network error while generating QR',
  'menus.view.eyebrow': 'Menu',
  'menus.view.emptyTitle': 'No sections in this menu yet.',
  'menus.view.emptyHint': 'Add sections and dishes from the menu editor to make this menu orderable.',
  'menus.view.locationHours': 'Location hours',
  'menus.view.showQR': 'Show QR',
  'menus.view.downloadPDF': 'Download PDF',
  'menus.view.designPrint': 'Design & Print',
  'menus.view.close': 'Close',
  'menus.view.qrTitle': 'Menu QR Code',
  'menus.view.qrGenerating': 'Generating QR…',
  'menus.view.qrNone': 'No QR yet',
  'menus.view.qrAlt': 'QR for {name}',
  'menus.view.copied': 'Copied',
  'menus.view.copyLink': 'Copy link',
  'menus.view.download': 'Download',
  'menus.view.sections': 'Sections',
  'menus.view.sectionsSummary': '{sections} · {dishes} dishes',
  'menus.view.expandAll': 'Expand all',
  'menus.view.collapseAll': 'Collapse all',
  'menus.view.dishCount.one': '· {n} dish',
  'menus.view.dishCount.other': '· {n} dishes',
  'menus.view.allDay': 'All day',
  'menus.view.noPrice': 'no price set',
  'menus.view.noDishes': 'No dishes in this section',
  // Wording printed onto the downloaded QR card.
  'menus.view.qrCard.restaurantFallback': 'Our Restaurant',
  'menus.view.qrCard.menuFallback': 'Our Menu',
  'menus.view.qrCard.hint': 'Point your phone camera at the code',
  'menus.view.qrCard.hint2': 'Browse the menu, dish by dish',

  // --- Menu list (per location) --------------------------------------------
  'menus.list.allLocations': 'All locations',
  'menus.list.eyebrow': 'Menu builder',
  'menus.list.status.all': 'All',
  'menus.list.status.active': 'Active',
  'menus.list.status.inactive': 'Inactive',
  'menus.list.type.all': 'All types',
  'menus.list.type.alacarte': 'À la carte',
  'menus.list.type.buffet': 'Buffet',
  'menus.list.loading': 'Loading menus…',
  'menus.list.emptyTitle': 'No menus yet',
  'menus.list.emptyHint': 'Create your first menu to get started',
  'menus.list.badge.notOnWebsite': 'Not on website',
  'menus.list.badge.notOnWebsiteTitle': 'Hidden from the public website. Still served on the QR menu and the order screen.',
  'menus.list.since': 'since {date}',
  'menus.list.sectionCount': '{n} section(s)',
  'menus.list.locationCount': '{n} locations',
  'menus.list.action.view': 'View',
  'menus.list.loadFailed': 'Failed to load menus',
  'menus.list.delete.title': 'Delete menu?',
  'menus.list.delete.description': 'Delete "{name}"? This will also delete all sections and items.',
  'menus.list.delete.confirm': 'Delete menu',
  'menus.list.deleted': 'Menu deleted successfully',
  'menus.list.deleteFailed': 'Failed to delete menu',
};

export const fr = {
  // --- Shared across the menu screens --------------------------------------
  // --- Kiosk: whether a self-order panel offers this card -------------------
  'menus.kiosk.label': 'Borne',
  'menus.kiosk.show': 'Afficher ce menu sur les bornes',
  'menus.kiosk.hint': 'Décochez et les bornes de commande ne le proposeront pas. Le menu QR, le site web et l’écran de commande ne sont pas affectés.',
  'menus.kiosk.notOn': 'Pas sur les bornes',

  'menus.toast.success': 'Succès',
  'menus.toast.error': 'Erreur',
  'menus.badge.active': '● Actif',
  'menus.noRestaurant': 'Aucun restaurant sélectionné. Veuillez d\'abord sélectionner un restaurant.',
  'menus.debugInfo': 'Infos de débogage :',
  'menus.goToSetup': 'Aller à la configuration du restaurant',

  // --- All Menu Items (catalogue) ------------------------------------------
  'menus.dishes.eyebrow': 'Catalogue du menu',
  'menus.dishes.count': '{shown} plats sur {total}',
  'menus.dishes.addItem': 'Ajouter un article',
  'menus.dishes.loadedCount': '{n} plats chargés',
  'menus.dishes.loadFailed': 'Échec du chargement des plats',

  // Plural type buckets — used by the "Show Only" filter and the Type grouping.
  'menus.dishes.type.dish': 'Plats',
  'menus.dishes.type.beverage': 'Boissons',
  'menus.dishes.type.addon': 'Suppléments',
  'menus.dishes.type.combo': 'Combos',
  'menus.dishes.type.store_bought': 'Achetés en magasin',
  'menus.dishes.type.bakery': 'Boulangerie',
  'menus.dishes.type.liquor': 'Alcools',
  'menus.dishes.group.uncategorized': 'Sans catégorie',
  'menus.dishes.group.other': 'Autre',
  'menus.dishes.group.items.one': '{n} article',
  'menus.dishes.group.items.other': '{n} articles',

  // Draft deletion
  'menus.dishes.deleteDraft.title': 'Supprimer le brouillon ?',
  'menus.dishes.deleteDraft.description': 'Supprimer le brouillon « {name} » ? Cette action est irréversible.',
  'menus.dishes.deleteDraft.done': 'Brouillon supprimé',
  'menus.dishes.deleteDraft.doneDesc': '« {name} » a été supprimé.',
  'menus.dishes.deleteDraft.failed': 'Échec de la suppression',
  'menus.dishes.deleteDraft.failedDesc': 'Impossible de supprimer le brouillon.',

  // Per-branch availability
  'menus.dishes.noLocation.title': 'Aucun établissement sélectionné',
  'menus.dishes.noLocation.desc': 'Choisissez d\'abord un établissement pour modifier la disponibilité sur ce site.',
  'menus.dishes.availableHere.title': 'Disponible ici',
  'menus.dishes.unavailableHere.title': 'Indisponible ici',
  'menus.dishes.availOnDesc': '« {name} » est maintenant au menu de commande à {location}.',
  'menus.dishes.availOffDesc': '« {name} » est maintenant retiré du menu de commande à {location}.',
  'menus.dishes.thisLocation': 'cet établissement',
  'menus.dishes.updateFailed': 'Échec de la mise à jour',
  'menus.dishes.availUpdateFailedDesc': 'Impossible de modifier la disponibilité.',
  'menus.dishes.availSaveFailedDesc': 'Impossible de mettre à jour la disponibilité.',
  'menus.dishes.deactivateHere.description': '« {name} » sera désactivé sur l\'écran de commande {where}. L\'article reste sur tous les menus et vous pouvez le réactiver à tout moment.',
  'menus.dishes.atLocation': 'à {location}',
  'menus.dishes.here': 'ici',
  'menus.dishes.availUpdated.title': 'Disponibilité mise à jour',
  'menus.dishes.availAllDesc': '« {name} » est disponible dans tous les établissements.',
  'menus.dishes.availOffCount.one': '« {name} » est désactivé dans {n} établissement sur {total}.',
  'menus.dishes.availOffCount.other': '« {name} » est désactivé dans {n} établissements sur {total}.',

  // Active / inactive lifecycle
  'menus.dishes.deactivateItem.title': 'Désactiver l\'article ?',
  'menus.dishes.deactivateItem.description': '« {name} » sera marqué Inactif et retiré de tous les menus (dans tous les établissements) jusqu\'à sa réactivation.',
  'menus.dishes.activated.title': 'Article activé',
  'menus.dishes.deactivated.title': 'Article désactivé',
  'menus.dishes.activated.desc': '« {name} » est maintenant actif.',
  'menus.dishes.deactivated.desc': '« {name} » est maintenant inactif.',
  'menus.dishes.statusFailedDesc': 'Impossible de modifier le statut.',

  // Badges
  'menus.dishes.badge.draft': 'Brouillon',
  'menus.dishes.badge.offHere': 'Coupé ici',
  'menus.dishes.badge.free': 'Gratuit',

  // Availability summary under the Status column
  'menus.dishes.summary.allLocations': 'Disponible dans les {n} établissements',
  'menus.dishes.summary.offCount': 'Désactivé dans {n} sur {total}',
  'menus.dishes.summary.availableAt': 'Disponible à {location}',
  'menus.dishes.summary.availableHere': 'Disponible ici',
  'menus.dishes.summary.deactivatedAt': 'Désactivé à {location}',
  'menus.dishes.summary.deactivatedHere': 'Désactivé ici',

  // Table row
  'menus.dishes.variants.hide': 'Masquer les variantes',
  'menus.dishes.variants.show': 'Afficher les variantes et les prix',
  'menus.dishes.statusTitle.active': 'Actif — cliquez pour désactiver (retiré de tous les menus)',
  'menus.dishes.statusTitle.inactive': 'Inactif — cliquez pour activer',
  'menus.dishes.action.view': 'Voir',
  'menus.dishes.action.viewTitle': 'Voir les détails',
  'menus.dishes.action.editTitle': 'Modifier l\'article',
  'menus.dishes.action.availability': 'Disponibilité',
  'menus.dishes.action.availabilityTitle': 'Gérer la disponibilité par établissement',
  'menus.dishes.action.deactivateTitle': 'Désactiver dans cet établissement',
  'menus.dishes.action.reactivate': 'Réactiver',
  'menus.dishes.action.reactivateTitle': 'Réactiver dans cet établissement',
  'menus.dishes.action.deleteDraftTitle': 'Supprimer ce brouillon',
  'menus.dishes.variantStandard': 'Standard',

  // Table columns
  'menus.dishes.column.name': 'Article',
  'menus.dishes.column.type': 'Type',
  'menus.dishes.column.variants': 'Variantes',
  'menus.dishes.column.created': 'Créé le',
  'menus.dishes.sortBy': 'Trier par {column}',

  // Read-only details panel
  'menus.dishes.view.category': 'Catégorie',
  'menus.dishes.view.created': 'Créé le',
  'menus.dishes.view.availability': 'Disponibilité',
  'menus.dishes.view.variants': 'Variantes ({n})',
  'menus.dishes.view.noVariants': 'Aucune variante.',
  'menus.dishes.view.ingredients': 'Ingrédients ({n})',
  'menus.dishes.view.noIngredients': 'Aucun ingrédient enregistré.',
  'menus.dishes.view.allergens': 'Allergènes :',
  'menus.dishes.view.recipe': 'Recette (par variante)',
  'menus.dishes.view.ingredientFallback': 'Ingrédient n° {id}',
  'menus.dishes.view.close': 'Fermer',

  // Filters
  'menus.dishes.filter.search': 'Rechercher des plats',
  'menus.dishes.filter.searchPlaceholder': 'Rechercher par nom, description ou catégorie...',
  'menus.dishes.filter.showOnly': 'Afficher uniquement',
  'menus.dishes.filter.allTypes': 'Tous les types',
  'menus.dishes.filter.groupBy': 'Grouper par',
  'menus.dishes.filter.noGrouping': 'Aucun groupement',
  'menus.dishes.filter.category': 'Catégorie',
  'menus.dishes.filter.type': 'Type (plat / boisson / supplément / …)',
  'menus.dishes.filter.status': 'Filtre de statut',
  'menus.dishes.filter.showActive': 'Afficher les actifs',
  'menus.dishes.filter.showInactive': 'Afficher les inactifs',

  // List states
  'menus.dishes.loading': 'Chargement des plats…',
  'menus.dishes.empty': 'Aucun plat pour l\'instant. Ajoutez votre premier plat pour commencer !',
  'menus.dishes.noMatches': 'Aucun plat ne correspond à vos filtres.',

  // Availability-by-location picker
  'menus.dishes.availDialog.title': 'Disponibilité par établissement',
  'menus.dishes.availDialog.descPrefix': 'Choisissez où',
  'menus.dishes.availDialog.descSuffix': 'est désactivé. Les établissements cochés sont désactivés ; l\'article reste sur tous les menus.',
  'menus.dishes.availDialog.clearAll': 'Tout décocher',
  'menus.dishes.availDialog.deactivateAll': 'Désactiver partout',
  'menus.dishes.availDialog.primary': 'Principal',
  'menus.dishes.availDialog.deactivated': 'Désactivé',
  'menus.dishes.availDialog.available': 'Disponible',

  // --- Simple dishes / beverages list --------------------------------------
  'menus.dishList.searchFilter': 'Recherche et filtres',
  'menus.dishList.searchByName': 'Rechercher par nom',
  'menus.dishList.searchPlaceholder': 'ex. : Butter Chicken',
  'menus.dishList.filterByCategory': 'Filtrer par catégorie',
  'menus.dishList.allCategories': 'Toutes les catégories',
  'menus.dishList.itemsPerPage': 'Articles par page',
  'menus.dishList.pageSize': '{n} articles',
  'menus.dishList.clear': 'Effacer',
  'menus.dishList.title.food': 'Plats',
  'menus.dishList.title.beverage': 'Boissons',
  'menus.dishList.results': '{shown} résultats affichés sur {total}',
  'menus.dishList.subtitle.food': 'Gérez tous les plats avec leurs variantes et leurs prix',
  'menus.dishList.subtitle.beverage': 'Gérez toutes les boissons avec leurs variantes et leurs prix',
  'menus.dishList.add.food': 'Ajouter un plat',
  'menus.dishList.add.beverage': 'Ajouter une boisson',
  'menus.dishList.empty.food': 'Aucun plat pour l\'instant',
  'menus.dishList.empty.beverage': 'Aucune boisson pour l\'instant',
  'menus.dishList.emptyHint.food': 'Ajoutez votre premier plat pour commencer',
  'menus.dishList.emptyHint.beverage': 'Ajoutez votre première boisson pour commencer',
  'menus.dishList.veg': 'Végé',
  'menus.dishList.vegan': 'Végan',
  'menus.dishList.variantsLabel': 'Variantes :',
  'menus.dishList.page': 'Page {n} sur {total}',
  'menus.dishList.previous': 'Précédent',
  'menus.dishList.next': 'Suivant',
  'menus.dishList.addVariantTitle': 'Ajouter une variante pour {name}',
  'menus.dishList.displayName': 'Nom affiché',
  'menus.dishList.dishNameWith': 'Nom du plat ({name})',
  'menus.dishList.custom': 'Personnalisé',
  'menus.dishList.size': 'Taille',
  'menus.dishList.unit': 'Unité',
  'menus.dishList.price': 'Prix',
  'menus.dishList.adding': 'Ajout en cours...',
  'menus.dishList.addVariant': 'Ajouter la variante',
  'menus.dishList.loadFailed': 'Échec du chargement des plats',
  'menus.dishList.searchFailed': 'Échec de la recherche de plats',
  'menus.dishList.variantMissing.title': 'Détails de la variante manquants',
  'menus.dishList.variantMissing.desc': 'Indiquez un libellé, une quantité ou un volume, et un prix pour la variante.',
  'menus.dishList.variantAdded': 'Variante ajoutée avec succès',
  'menus.dishList.variantAddFailed': 'Échec de l\'ajout de la variante',

  // --- Menu preview (read-only) --------------------------------------------
  'menus.view.loading': 'Chargement du menu...',
  'menus.view.loadFailed': 'Échec du chargement du menu',
  'menus.view.qrFailed': 'Échec de la génération du QR',
  'menus.view.qrNetworkError': 'Erreur réseau lors de la génération du QR',
  'menus.view.eyebrow': 'Menu',
  'menus.view.emptyTitle': 'Aucune section dans ce menu pour l\'instant.',
  'menus.view.emptyHint': 'Ajoutez des sections et des plats depuis l\'éditeur de menu pour rendre ce menu commandable.',
  'menus.view.locationHours': 'Horaires de l\'établissement',
  'menus.view.showQR': 'Afficher le QR',
  'menus.view.downloadPDF': 'Télécharger le PDF',
  'menus.view.designPrint': 'Design et impression',
  'menus.view.close': 'Fermer',
  'menus.view.qrTitle': 'QR code du menu',
  'menus.view.qrGenerating': 'Génération du QR…',
  'menus.view.qrNone': 'Pas encore de QR',
  'menus.view.qrAlt': 'QR pour {name}',
  'menus.view.copied': 'Copié',
  'menus.view.copyLink': 'Copier le lien',
  'menus.view.download': 'Télécharger',
  'menus.view.sections': 'Sections',
  'menus.view.sectionsSummary': '{sections} · {dishes} plats',
  'menus.view.expandAll': 'Tout déplier',
  'menus.view.collapseAll': 'Tout replier',
  'menus.view.dishCount.one': '· {n} plat',
  'menus.view.dishCount.other': '· {n} plats',
  'menus.view.allDay': 'Toute la journée',
  'menus.view.noPrice': 'prix non défini',
  'menus.view.noDishes': 'Aucun plat dans cette section',
  // Wording printed onto the downloaded QR card.
  'menus.view.qrCard.restaurantFallback': 'Notre restaurant',
  'menus.view.qrCard.menuFallback': 'Notre menu',
  'menus.view.qrCard.hint': 'Pointez l\'appareil photo de votre téléphone vers le code',
  'menus.view.qrCard.hint2': 'Parcourez le menu, plat par plat',

  // --- Menu list (per location) --------------------------------------------
  'menus.list.allLocations': 'Tous les établissements',
  'menus.list.eyebrow': 'Créateur de menus',
  'menus.list.status.all': 'tous',
  'menus.list.status.active': 'actifs',
  'menus.list.status.inactive': 'inactifs',
  'menus.list.type.all': 'Tous les types',
  'menus.list.type.alacarte': 'À la carte',
  'menus.list.type.buffet': 'Buffet',
  'menus.list.loading': 'Chargement des menus…',
  'menus.list.emptyTitle': 'Aucun menu pour l\'instant',
  'menus.list.emptyHint': 'Créez votre premier menu pour commencer',
  'menus.list.badge.notOnWebsite': 'Pas sur le site web',
  'menus.list.badge.notOnWebsiteTitle': 'Masqué sur le site web public. Toujours proposé sur le menu QR et sur l\'écran de commande.',
  'menus.list.since': 'depuis le {date}',
  'menus.list.sectionCount': '{n} section(s)',
  'menus.list.locationCount': '{n} établissements',
  'menus.list.action.view': 'Voir',
  'menus.list.loadFailed': 'Échec du chargement des menus',
  'menus.list.delete.title': 'Supprimer le menu ?',
  'menus.list.delete.description': 'Supprimer « {name} » ? Toutes les sections et tous les articles seront également supprimés.',
  'menus.list.delete.confirm': 'Supprimer le menu',
  'menus.list.deleted': 'Menu supprimé avec succès',
  'menus.list.deleteFailed': 'Échec de la suppression du menu',
};
